import { PricingPlanType, useConfig } from '@portals/api/partners';
import { TenantType } from '@portals/types';

export function usePricingPlanFeatures() {
  const config = useConfig();

  return config.data?.[TenantType.Partner]?.pricing_plan?.features;
}

export function usePricingPlanFeature(
  feature: keyof PricingPlanType['features']
) {
  const pricingPlanFeatures = usePricingPlanFeatures();

  return pricingPlanFeatures?.[feature];
}

export function useIsPricingPlanFeatureEnabled(
  feature: keyof PricingPlanType['features']
) {
  const featureValue = usePricingPlanFeature(feature);

  return Boolean(featureValue);
}

export function usePricingPlan() {
  const config = useConfig();

  return config.data?.[TenantType.Partner]?.pricing_plan?.name;
}

export function useIsFreePricingPlan() {
  const pricingPlan = usePricingPlan();

  return pricingPlan === 'free';
}
